import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { transcriptsCopy } from '../../copy/transcripts';

// ---------------------------------------------------------------------------
// ConfidenceBadge — renders an AI-extraction confidence score (0..1) as a
// colour-coded chip. Green ≥ 0.8, amber 0.6–0.79, red < 0.6. Tooltip explains
// what the band means so users know whether to Accept or Dismiss at a glance.
// ---------------------------------------------------------------------------

interface ConfidenceBadgeProps {
  score: number;
}

export function ConfidenceBadge({ score }: ConfidenceBadgeProps) {
  const pct = Math.round(score * 100);

  let color = '#FF5252'; // breach / red
  let bg = 'rgba(255, 82, 82, 0.15)';
  let tooltip: string = transcriptsCopy.confidenceTooltipLow;

  if (score >= 0.8) {
    color = '#69F0AE';
    bg = 'rgba(105, 240, 174, 0.15)';
    tooltip = transcriptsCopy.confidenceTooltipHigh;
  } else if (score >= 0.6) {
    color = '#FFB74D';
    bg = 'rgba(255, 183, 77, 0.15)';
    tooltip = transcriptsCopy.confidenceTooltipMedium;
  }

  return (
    <Tooltip title={tooltip} placement="top" arrow>
      <Chip
        label={`${pct}%`}
        size="small"
        sx={{ bgcolor: bg, color, fontWeight: 600, minWidth: 48 }}
      />
    </Tooltip>
  );
}

export default ConfidenceBadge;
